import React from 'react'

const Checked:React.FC = () => {
  return (
    <div className="success-icon">
      <div className="circle">
        <div className="checkmark">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <path
              className="checkmark-path"
              fill="none"
              stroke="#bfc221"
              strokeWidth="4"
              d="M14 27l7 7 16-16"
            />
          </svg>
        </div>
      </div>
    </div>
  )
}

export default Checked